/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_DobInputs */

const th_player_dob = /** @type {(inputs: Player_DobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วันเกิด`)
};

const en_player_dob = /** @type {(inputs: Player_DobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date of birth`)
};

const ja_player_dob = /** @type {(inputs: Player_DobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生年月日`)
};

const zh_player_dob = /** @type {(inputs: Player_DobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出生日期`)
};

const es_player_dob = /** @type {(inputs: Player_DobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de nacimiento`)
};

const pt_player_dob = /** @type {(inputs: Player_DobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data de nascimento`)
};

const id_player_dob = /** @type {(inputs: Player_DobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanggal lahir`)
};

const fr_player_dob = /** @type {(inputs: Player_DobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date de naissance`)
};

const tl_player_dob = /** @type {(inputs: Player_DobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Petsa ng kapanganakan`)
};

const vi_player_dob = /** @type {(inputs: Player_DobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày sinh`)
};

const ko_player_dob = /** @type {(inputs: Player_DobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`생년월일`)
};

const de_player_dob = /** @type {(inputs: Player_DobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geburtsdatum`)
};

const ru_player_dob = /** @type {(inputs: Player_DobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата рождения`)
};

const tr_player_dob = /** @type {(inputs: Player_DobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doğum tarihi`)
};

const it_player_dob = /** @type {(inputs: Player_DobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data di nascita`)
};

const pl_player_dob = /** @type {(inputs: Player_DobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data urodzenia`)
};

const uk_player_dob = /** @type {(inputs: Player_DobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата народження`)
};

const hi_player_dob = /** @type {(inputs: Player_DobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जन्म तिथि`)
};

const ar_player_dob = /** @type {(inputs: Player_DobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تاريخ الميلاد`)
};

const ms_player_dob = /** @type {(inputs: Player_DobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarikh lahir`)
};

const bn_player_dob = /** @type {(inputs: Player_DobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`জন্মতারিখ`)
};

const zh_tw2_player_dob = /** @type {(inputs: Player_DobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出生日期`)
};

const zh_hk2_player_dob = /** @type {(inputs: Player_DobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出生日期`)
};

const ur_player_dob = /** @type {(inputs: Player_DobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تاریخِ پیدائش`)
};

const fa_player_dob = /** @type {(inputs: Player_DobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تاریخ تولد`)
};

const sw_player_dob = /** @type {(inputs: Player_DobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarehe ya kuzaliwa`)
};

const nl_player_dob = /** @type {(inputs: Player_DobInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geboortedatum`)
};

/**
* | output |
* | --- |
* | "Date of birth" |
*
* @param {Player_DobInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const player_dob = /** @type {((inputs?: Player_DobInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_DobInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_player_dob(inputs)
	if (locale === "ja") return ja_player_dob(inputs)
	if (locale === "zh") return zh_player_dob(inputs)
	if (locale === "es") return es_player_dob(inputs)
	if (locale === "pt") return pt_player_dob(inputs)
	if (locale === "id") return id_player_dob(inputs)
	if (locale === "fr") return fr_player_dob(inputs)
	if (locale === "tl") return tl_player_dob(inputs)
	if (locale === "vi") return vi_player_dob(inputs)
	if (locale === "ko") return ko_player_dob(inputs)
	if (locale === "de") return de_player_dob(inputs)
	if (locale === "ru") return ru_player_dob(inputs)
	if (locale === "tr") return tr_player_dob(inputs)
	if (locale === "it") return it_player_dob(inputs)
	if (locale === "pl") return pl_player_dob(inputs)
	if (locale === "uk") return uk_player_dob(inputs)
	if (locale === "hi") return hi_player_dob(inputs)
	if (locale === "ar") return ar_player_dob(inputs)
	if (locale === "ms") return ms_player_dob(inputs)
	if (locale === "bn") return bn_player_dob(inputs)
	if (locale === "zh-TW") return zh_tw2_player_dob(inputs)
	if (locale === "zh-HK") return zh_hk2_player_dob(inputs)
	if (locale === "ur") return ur_player_dob(inputs)
	if (locale === "fa") return fa_player_dob(inputs)
	if (locale === "sw") return sw_player_dob(inputs)
	if (locale === "nl") return nl_player_dob(inputs)
	return en_player_dob(inputs)
});